import * as types from './shipmentActionTypes';

const initialState = {
  shipmentList: [],
  shipmentData: null,
  isLoading: false,
  error: null,
  addShipmentData: null,
  updateShipmentData: null,
  deleteShipmentData: null,
  // Sayfalama alanları
  totalCount: 0,
  pageNumber: 1,
  pageSize: 10,
  totalPages: 0,
  hasPreviousPage: false,
  hasNextPage: false,
};

export const shipmentReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.GET_SHIPMENT_REQUEST:
      return { ...state, isLoading: true, error: null };
    case types.GET_SHIPMENT_SUCCESS:
      return { 
        ...state, 
        isLoading: false, 
        shipmentList: action.payload?.ShipmentList || [],
        totalCount: action.payload?.TotalCount || 0,
        pageNumber: action.payload?.PageNumber || 1,
        pageSize: action.payload?.PageSize || 10,
        totalPages: action.payload?.TotalPages || 0,
        hasPreviousPage: action.payload?.HasPreviousPage || false,
        hasNextPage: action.payload?.HasNextPage || false,
        error: null 
      };
    case types.GET_SHIPMENT_ERROR:
      return { ...state, isLoading: false, error: action.payload };

    case types.ADD_SHIPMENT_REQUEST:
      return { ...state, isLoading: true, error: null };
    case types.ADD_SHIPMENT_SUCCESS:
      return { ...state, isLoading: false, addShipmentData: action.payload, error: null };
    case types.ADD_SHIPMENT_ERROR:
      return { ...state, isLoading: false, error: action.payload };

    case types.UPDATE_SHIPMENT_REQUEST:
      return { ...state, isLoading: true, error: null };
    case types.UPDATE_SHIPMENT_SUCCESS:
      return { ...state, isLoading: false, updateShipmentData: action.payload, error: null };
    case types.UPDATE_SHIPMENT_ERROR:
      return { ...state, isLoading: false, error: action.payload };

    case types.DELETE_SHIPMENT_REQUEST:
      return { ...state, isLoading: true, error: null };
    case types.DELETE_SHIPMENT_SUCCESS:
      return { ...state, isLoading: false, deleteShipmentData: action.payload, error: null };
    case types.DELETE_SHIPMENT_ERROR:
      return { ...state, isLoading: false, error: action.payload };

    default:
      return state;
  }
}; 